import { render, staticRenderFns } from "./perCenterPage.vue?vue&type=template&id=43d53c0b&"
import script from "./perCenterPage.vue?vue&type=script&lang=js&"
export * from "./perCenterPage.vue?vue&type=script&lang=js&"
import style0 from "./perCenterPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports